import { useLocalStorage } from '@vueuse/core'

/** Customer-wide, not per discipline — the first-lesson onboarding runs once and never repeats on the second discipline. */
const POPUPS_COMPLETED_KEY = 'onboarding_first_lesson_popups_completed'
const SKIP_INTRO_KEY = 'onboarding_first_lesson_skip_intro'

/** The 3-step join-first-lesson flow has been seen through or dismissed. */
export const lsFirstLessonPopupsCompleted = useLocalStorage<boolean>(POPUPS_COMPLETED_KEY, false)

/** The welcome-email attend modal already covered step 1, so that step is dropped. */
export const lsFirstLessonIntroSkipped = useLocalStorage<boolean>(SKIP_INTRO_KEY, false)
